import React, { Component } from 'react';
import { Translation } from 'giro-react-toolkit/source/Translation';
import Carousel from "Carousel";
import OnBoardingItem from "./OnBoardingItem";

import busImage from "../images/onboarding-bus.png";

import "./OnBoarding.scss";

/**
 * Component that shows the OnBoarding modal
 */
class OnBoarding extends Component {
   constructor(props) {
      super(props);
   }

   /**
    * renders the OnBoarding component
    */
   render() {
      if (!this.props.show)
         return (null);

      return (
         <React.Fragment>
            <div className="onboarding">
               <button className="onboarding__header-close button--icon-only button--icon-close" onClick={ this.props.onClose }></button>
               <Carousel
                  className="onboarding__carousel"
                  prevText={<Translation resourceKey={ 'ReachMapRes.PrevText' } />}
                  nextText={<Translation resourceKey={ 'ReachMapRes.NextText' } />}
                  doneText={<Translation resourceKey={ 'ReachMapRes.DoneText' } />}
                  onDone={ this.props.onClose }>
                  <OnBoardingItem
                     image = { busImage }
                     firstSummary={{
                        title: <Translation resourceKey={ 'ReachMapRes.OnBoardingWelcomeSummaryTitle' } />,
                        description: <Translation resourceKey={ 'ReachMapRes.OnBoardingWelcomeSummaryDescription' } />
                     }}
                     secondSummary={{
                        title: <Translation resourceKey={ 'ReachMapRes.OnBoardingTakeGlimpseSummaryTitle' } />,
                        description: <Translation resourceKey={ 'ReachMapRes.OnBoardingTakeGlimpseSummaryDescription' } />
                     }}/>
               </Carousel>
            </div>
            <div className="onboarding-overlay"></div>
         </React.Fragment>
      );
   }
}

export default OnBoarding;
